import {course_getCourseClassById_Api} from 'apis'
import classNames from 'classnames'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import _ from 'lodash'
import React, {useState} from 'react'
import {BsCalendar2Week, BsGearFill} from 'react-icons/bs'
import {FaUserGraduate, FaUserTie} from 'react-icons/fa6'
import {PiChecks, PiGraduationCap} from 'react-icons/pi'
import {CourseClassStudentList} from 'views/AppLocals/Course/CourseClass/CourseClassStudentForm'
import CourseClassTeachers from 'views/AppLocals/Course/CourseClass/CourseClassTeachers'
import {EditCourseClassModal} from 'views/AppLocals/Course/CourseClass/CourseClassForm'
import {useCourseClassApi} from 'views/AppLocals/Course/CourseClass/useCourseClassApi'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import {NullAsDefault} from 'views/Shared'
import {bindingSearch} from 'views/Shared/components/PagerControls'
import LoadingBlock from 'views/Loading/LoadingBlock'
import {CourseClassTimetablePanel} from './CourseClassTimetablePanel'
import {CourseClassAttendancePanel} from './CourseClassAttendancePanel'
import {CourseClassGradingPanel} from './CourseClassGradingPanel'
import {ClassInfoBanner} from '../../components/ClassInfoBanner'

// Danh sách tab + thứ tự ĐỒNG BỘ với CourseClassDetail.js (trang "Điều hành Khóa & Lớp học") - popup
// này và trang đó trước đây là 2 nơi tự vẽ tab/nội dung riêng cho CÙNG 1 khái niệm "chi tiết lớp học"
// (lệch nhau: popup có tab "Môn học" riêng bằng CourseClassSubjectList, trang không có; trang có tab
// "Cấu hình Lớp học", popup không có) - nay quy về 1 bộ tab. Tab "Môn học" đã BỎ ở đây giống trang
// (không mất chức năng - đã chuyển thành chip-select CourseClassSubjectChips NGAY TRONG tab "Cấu hình
// Lớp học" bên dưới, dùng lại NGUYÊN api link/unlink, xem comment trong CourseClassSubjectForm.js).
const SIDE_TABS = [
    {key: 'schedule', name: 'timetable', icon: <BsCalendar2Week size={16}/>},
    {key: 'teacher', name: 'teacher', icon: <FaUserTie size={14}/>},
    {key: 'student', name: 'student', icon: <FaUserGraduate size={14}/>},
    {key: 'attendance', name: 'attendance', icon: <PiChecks size={16}/>},
    {key: 'grading', name: 'gradebook', icon: <PiGraduationCap size={16}/>},
    {key: 'settings', name: 'class settings', icon: <BsGearFill size={16}/>},
]

const SideTabNav = ({tabs, activeTab, onTabChange}) => {
    const t = useTranslate()
    return (
        <div className="flex gap-1 overflow-x-auto background-100 border-b border-color-300">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={classNames(
                        'px-3 py-2 flex items-center flex-shrink-0 gap-2 text-xs font-medium transition-colors border-b-2',
                        activeTab === tab.key
                            ? 'border-indigo-500 text-indigo-600'
                            : 'border-transparent text-color-200 hover:text-indigo-500 hover:border-indigo-300'
                    )}>
                    {tab.icon}
                    <span>{t(tab.name)}</span>
                </button>
            ))}
        </div>
    )
}

export const CourseClassPanelDetail = ({
                                            class_id, owner_id, owner_type,
                                            initialTab = 'schedule',
                                            onCancel = NullAsDefault,
                                            onTabChange = NullAsDefault,
                                            // Gọi sau khi Sửa/Xóa lớp thành công ở tab "Cấu hình Lớp học" (bên dưới) - để
                                            // danh sách lớp (ClassListManager) refresh lại cột "Giảng viên"/"Học viên",
                                            // KHÔNG tự đóng popup (khác với xóa - xóa thì popup tự đóng vì lớp không còn tồn tại).
                                            onChanged = NullAsDefault,
                                        }) => {
    const t = useTranslate()
    const [activeTab, setActiveTab] = useState(initialTab)

    const handleTabChange = (tab) => {
        setActiveTab(tab)
        onTabChange(tab)
    }
    const [item, setItem] = useState(null)

    const {handleAsyncAction: fetchById} = useAsyncAction({
        apiInfo: course_getCourseClassById_Api,
        onSuccess: (result, data) => {
            setItem(_.get(data, 'response.data'))
        },
    })

    React.useEffect(() => {
        if (class_id) fetchById({}, {id: class_id})
    }, [class_id])

    // onUpdate/onDelete cho tab "Cấu hình Lớp học" - SAU KHI sửa thì fetch lại item để header (tên,
    // sĩ số...) và form cập nhật đúng bản mới nhất; sau khi xóa thì đóng popup (lớp không còn) + báo
    // ClassListManager refresh danh sách (onChanged).
    const {onUpdate: onEditCourseClass, onDelete: onDeleteCourseClass} = useCourseClassApi({
        onUpdated: () => {
            fetchById({}, {id: class_id})
            onChanged()
        },
        onDeleted: () => {
            onChanged()
            onCancel()
        },
    })

    if (!item) return <LoadingBlock/>

    const course = item?.course ?? {}

    const renderContent = () => {
        switch (activeTab) {
            case 'schedule':
                return (
                    <CourseClassTimetablePanel item={item}/>
                )
            case 'student':
                return (
                    <div className="flex flex-col gap-3">
                        {/* Nút "final assessment" riêng ở đây đã BỎ - trùng chức năng với icon
                            "final assessment" (TbTableOptions) sẵn có ở từng dòng của bảng
                            "Danh sách Lớp học" (CourseClassList.js, onSummaryClick), vẫn mở đúng
                            CourseClassSummaryPanel đó - không mất chức năng, chỉ bỏ lối tắt trùng. */}
                        {!!item?.id && bindingSearch({
                            onCancel,
                            owner_id: item?.owner?.id,
                            owner_type: item?.owner?._type,
                            item,
                            onCourseClassChange: setItem,
                        })(CourseClassStudentList)}
                    </div>
                )
            case 'teacher':
                return (
                    <div className="flex flex-col">
                        {!!item?.id && bindingSearch({
                            onCancel,
                            owner_id: item?.owner?.id,
                            owner_type: item?.owner?._type,
                            item,
                        })(CourseClassTeachers)}
                    </div>
                )
            case 'settings':
                return (
                    <div className="flex flex-col">
                        <div className="mb-4 flex flex-col flex-1">
                            <h3 className="font-bold text-base text-slate-600 tracking-wide">
                                {t('class settings')}
                            </h3>
                            <div style={{height: 3}} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                            <div className="text-color-300 tracking-wider">
                                {t('manage name description start end dates')}
                            </div>
                        </div>
                        <EditCourseClassModal
                            item={item}
                            owner_id={item?.owner?.id}
                            owner_type={item?.owner?._type}
                            container={course}
                            onSubmit={(values) => onEditCourseClass(values, {id: item?.id})}
                        />
                        {/* "Xóa lớp học" - ĐÚNG khối nguy hiểm (viền/nền đỏ, không badge rườm rà) như
                            tab "Cấu hình Lớp học" bên CourseClassDetail.js, xem comment ở đó. */}
                        <div className="mt-8 p-4 rounded-xl border-2 border-red-200 bg-red-50 flex flex-col">
                            <div className="mb-3 flex flex-col flex-1">
                                <h3 className="font-bold text-base text-red-700 tracking-wide">
                                    {t('delete class')}
                                </h3>
                                <div className="text-red-500 tracking-wider">
                                    {t('this action will permanently delete the class and all related data please confirm before proceeding')}
                                </div>
                            </div>
                            <div className="flex justify-end">
                                <button
                                    onClick={() => showDeleteConfirmDialog({
                                        translate: t,
                                        title: 'delete class of course',
                                        message: 'are you sure you want to delete this class of course',
                                        onOk: () => onDeleteCourseClass({}, {id: item?.id}),
                                    })}
                                    className="px-6 py-2 bg-red-600 hover:bg-red-700 shadow-md rounded-lg font-medium text-white">
                                    {t('delete class permanently')}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            case 'attendance':
                return (
                    <div className="flex flex-col gap-3">
                        <CourseClassAttendancePanel item={item}/>
                    </div>
                )
            case 'grading':
                return (
                    <div className="flex flex-col gap-3">
                        <CourseClassGradingPanel item={item}/>
                    </div>
                )
            default:
                return null
        }
    }

    return (
        <div className="flex flex-col gap-3">
            {/* Dùng CHUNG ClassInfoBanner với CourseClassDetail.js (trang "Điều hành Khóa & Lớp học") -
                trước đây popup này tự vẽ 1 khối trắng riêng, thiếu hẳn danh sách môn học (bạn báo lệch
                UI giữa 2 nơi cùng hiển thị "chi tiết lớp"). showCourseTitle - popup KHÔNG có breadcrumb
                "quay lại khóa" như trang kia nên giữ tên khóa ngay trong banner (xem ClassInfoBanner.js). */}
            <ClassInfoBanner item={item} showCourseTitle/>
            <SideTabNav tabs={SIDE_TABS} activeTab={activeTab} onTabChange={handleTabChange}/>
            <div className="mt-1">
                {renderContent()}
            </div>
        </div>
    )
}
